// ----------------------------------------------------------------------------
// Video-Block (Helpers)
// ----------------------------------------------------------------------------

import $ from 'jquery';
import Vimeo from '@vimeo/player';
//import BrowserDetect from '../sections/browser-detect';

var CONTROLS_PLAY   = '.video-block__control--play';
var CONTROLS_PAUSE  = '.video-block__control--pause';
var CONTROLS_MUTE   = '.video-block__control--mute';
var CONTROLS_UNMUTE = '.video-block__control--unmute';

// Prepare Control Interactions
var videoBlockControls = {
    play: function(videoBlock) {
        $(videoBlock)
            .removeClass('video-block--is-postered')//.css('background-image', '')  // Remove the poster (if present)
            .removeClass('video-block--is-paused')                                // Indicate video is playing (i.e. not paused)
        ;
    },

    pause: function(videoBlock) {
        $(videoBlock)
            .addClass('video-block--is-paused')                                   // Indicate video is paused
        ;
    },

    mute: function(videoBlock) {
        $(videoBlock)
            .addClass('video-block--is-muted')                                    // Indicate video is muted
        ;
    },

    unmute: function(videoBlock) {
        $(videoBlock)
            .removeClass('video-block--is-muted')                                 // Indicate video is not muted
        ;
    }
};


// Manage Custom Controls via video-block events
$('.video-block').each(function() {

    // Bind Listeners for Custom Controls
    // -------------------------------------------------------------------

    // Bind Play button
    $(this).find(CONTROLS_PLAY).on('click', function() {
        videoBlockControls.play($(this).parents('.video-block')); // Provide immediate feedback (since video might need to queue before callback fires)

        $(this).parents('.video-block').trigger('play.video-block');
    });

    // Bind Pause button
    $(this).find(CONTROLS_PAUSE).on('click', function() {
        $(this).parents('.video-block').trigger('pause.video-block');
    });

    // Bind Mute button
    $(this).find(CONTROLS_MUTE).on('click', function() {
        $(this).parents('.video-block').trigger('mute.video-block');
    });

    // Bind Unmute button
    $(this).find(CONTROLS_UNMUTE).on('click', function() {
        $(this).parents('.video-block').trigger('unmute.video-block');
    });


    // Listen to video-block events and update Custom Controls accordingly
    // -------------------------------------------------------------------

    // Video is playing
    $(this).on('onplay.video-block', function() {
        videoBlockControls.play(this);
    });

    // Video is paused
    $(this).on('onpause.video-block', function() {
        videoBlockControls.pause(this);
    });

    // Video has ended
    $(this).on('onended.video-block', function() {
        videoBlockControls.pause(this);
    });

    // Video has been muted
    $(this).on('onmute.video-block', function() {
        videoBlockControls.mute(this);
    });

    // Video has been unmuted
    $(this).on('onunmute.video-block', function() {
        videoBlockControls.unmute(this);
    });
});

// ----------------------------------------------------------------------------
// Browser Fixes
// ----------------------------------------------------------------------------

// HTML5 Browser Support stuff
// var handleBrowsers = {

//     handleBrowsers: function () {

//         // For touch iOS and Android, allow interactivity on mute-only videos.  By default muted-only autoplays, but since touch screens do not autoplay, we need to allow user interaction.
//         if( BrowserDetect.os == 'iOS' || BrowserDetect.os == 'Android') {
//             $('.video-block.video-block--is-not-interactive.video-block--is-muted').each(function() {
//                 $(this).removeClass('video-block--is-not-interactive');
//             });
//         }

//         // Remove mute buttons on iOS Youtube since the volume is taken from the device setting
//         if(BrowserDetect.os == 'iOS') {
//             $('.video-block.video-block--youtube').each(function() {
//                 $(this).find('.video-block__control--unmute, .video-block__control--mute').remove();
//             });
//         }

//     }
// };

// Initialize
//handleBrowsers.handleBrowsers();


// ----------------------------------------------------------------------------
// YouTube Video
// ----------------------------------------------------------------------------
var youtubeVideo = {

    init: function() {
        // Load YouTube API and when it's ready, init the players
        var tag = document.createElement('script');
        var firstScriptTag = document.getElementsByTagName('script')[0];

        tag.src = 'https://www.youtube.com/iframe_api';
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        window.onYouTubeIframeAPIReady = function() {
            youtubeVideo.initVideos();
        };
    },

    initVideos: function() {

        // Initialize YouTube Videos
        $('.video-block--youtube').each(function() {
            var video            = youtubeVideo.getVideo(this);
            var video_iframe     = $(video).append('<div />').find('div').get(0);
            var video_settings   = $(video).data('video-settings');

            var video_id         = video_settings.video_id;

            // Initialize YouTube Player
            // Docs: https://developers.google.com/youtube/player_parameters#Parameters
            var player = new YT.Player(video_iframe, {
                videoId: video_id,
                playerVars: {
                    listType:       video_settings.playlist_id != null ? 'playlist' : null,
                    list:           video_settings.playlist_id,
                    playlist:       video_settings.playlist_id == null && video_settings.is_looped ? video_id : null, // Workaround for looping a single video
                    loop:           video_settings.is_looped   ? 1 : 0,
                    autoplay:       video_settings.is_autoplay ? 1 : 0,
                    controls:       video_settings.is_controls ? 1 : 0,
                    disablekb:      video_settings.is_controls ? 0 : 1,
                    playsinline:    video_settings.is_autoplay ? 1 : 0, // Play the video inline (not fullscreen) on iOS with autoplay enabled
                    showinfo:       0,  // Hide video title / uploader overlay
                    modestbranding: 1,  // Minimize YouTube branding
                    fs:             1,  // Enable "full screen"
                    cc_load_policy: 0,  // Disable closed captions by default
                    iv_load_policy: 3,  // Disable video annotations by default
                    rel:            0   // Disable "related videos" after playing
                },
                events: {
                    'onStateChange': youtubeVideo.onPlayerStateChange,
                    'onReady':       youtubeVideo.onPlayerReady
                }
            });
        });
    },

    onPlayerReady: function(event) {
        var player         = event.target;
        var video          = youtubeVideo.getVideo(player.getIframe());
        var video_settings = $(video).data('video-settings');

        // Sets the initial player volume
        player.setVolume(video_settings.is_muted ? 0 : 100);


        // Bind Custom Controls
        $(video).parents('.video-block').on('play.video-block',   { player: player }, youtubeVideo.play);
        $(video).parents('.video-block').on('pause.video-block',  { player: player }, youtubeVideo.pause);
        $(video).parents('.video-block').on('mute.video-block',   { player: player }, youtubeVideo.mute);
        $(video).parents('.video-block').on('unmute.video-block', { player: player }, youtubeVideo.unmute);
    },


    // Listens to state change of Youtube, and relays back the proper button states
    onPlayerStateChange: function(event) {
        var youtubeVideo_iframe = event.target.getIframe();
        // Listen to YouTube "events" and update the Custom Controls accordingly
        if (event.data == YT.PlayerState.PLAYING) {
            $(youtubeVideo_iframe).parents('.video-block').trigger('onplay.video-block');
        }

        if (event.data == YT.PlayerState.PAUSED) {
            $(youtubeVideo_iframe).parents('.video-block').trigger('onpause.video-block');
        }

        if (event.data == YT.PlayerState.ENDED) {
            $(youtubeVideo_iframe).parents('.video-block').trigger('onended.video-block');
        }
    },

    play: function(event) {
        event.data.player.playVideo();
    },

    pause: function(event) {
        event.data.player.pauseVideo();
    },

    mute: function(event) {
        event.data.player.mute();

        // Trigger mute event (YouTube doesn't fire it's own volume change events)
        $(event.data.player.getIframe()).parents('.video-block').trigger('onmute.video-block');
    },

    unmute: function(event) {
        event.data.player.unMute();

        // Trigger mute event (YouTube doesn't fire it's own volume change events)
        $(event.data.player.getIframe()).parents('.video-block').trigger('onunmute.video-block');
    },


    getVideo: function(element) {
        return $(element).closest('.video-block').find('.video-block__video').get(0);
    }
};

// Initialize YouTube Video
youtubeVideo.init();

// ----------------------------------------------------------------------------
// Vimeo Video
// ----------------------------------------------------------------------------

var vimeoVideo = {

    init: function() {
        // Initialize Vimeo Videos
        $('.video-block--vimeo').each(function() {
            var video            = $(this).find('.video-block__video').get(0);
            var video_settings   = $(video).data('video-settings');
            var video_id         = Number(video_settings.video_id);


            // Initialize any "Default Posters"
            if (video_settings.lookup_poster) {
                $.ajax({
                    type:     'GET',
                    url:      'https://vimeo.com/api/v2/video/' + video_id + '.json',
                    jsonp:    'callback',
                    dataType: 'jsonp',
                    success: function(data) {
                        // Show the poster
                        $(video).parents('.video-block')
                            .addClass('video-block--is-postered')
                           .css('background-image', 'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(' + data[0].thumbnail_large + ')')
                        ;
                    },
                    error: function() {
                        // Clean up, just in case
                        $(video).parents('.video-block')
                            .removeClass('video-block--is-postered')
                            .css('background-image', '')
                        ;
                    }
                });
            }

            // Initialize Vimeo Player
            // Docs: https://github.com/vimeo/player.js#embed-options
            var player = new Vimeo(video, {
                id:        video_id,
                loop:      video_settings.is_looped,
                autoplay:  video_settings.is_autoplay,
                autopause: !video_settings.is_autoplay,
                title:     false,
                portrait:  false,
                byline:    false
            });

            // Sets the initial player volume
            player.setVolume(video_settings.is_muted ? 0 : 1);


            // Listen to Vimeo "events" and update the Custom Controls accordingly
            player.on('play', function(data) {
                $(this.element).parents('.video-block').trigger('onplay.video-block');
            });

            player.on('pause', function(data) {
                $(this.element).parents('.video-block').trigger('onpause.video-block');
            });

            player.on('ended', function(data) {
                $(this.element).parents('.video-block').trigger('onended.video-block');
            });

            player.on('volumechange', function(data) {
                if (data.volume == 0) {
                    $(this.element).parents('.video-block').trigger('onmute.video-block');
                }
                else {
                    $(this.element).parents('.video-block').trigger('onunmute.video-block');
                }
            });


            // Bind Custom Controls
            $(this).on('play.video-block',   { player: player }, vimeoVideo.play);
            $(this).on('pause.video-block',  { player: player }, vimeoVideo.pause);
            $(this).on('mute.video-block',   { player: player }, vimeoVideo.mute);
            $(this).on('unmute.video-block', { player: player }, vimeoVideo.unmute);
        });
    },

    play: function(event) {
        event.data.player.play();
    },

    pause: function(event) {
        event.data.player.pause();
    },

    mute: function(event) {
        event.data.player.setVolume(0);
    },

    unmute: function(event) {
        event.data.player.setVolume(1);
    }
};

// Initialize HTML5 Video
vimeoVideo.init();
